'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactI18next = require('react-i18next');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _InlineColorSwatchStyle = require('./InlineColorSwatchStyle.scss');

var _InlineColorSwatchStyle2 = _interopRequireDefault(_InlineColorSwatchStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InlineColorSwatch = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _reactCssModules2.default)(_InlineColorSwatchStyle2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(InlineColorSwatch, _React$Component);

  function InlineColorSwatch() {
    (0, _classCallCheck3.default)(this, InlineColorSwatch);
    return (0, _possibleConstructorReturn3.default)(this, (InlineColorSwatch.__proto__ || (0, _getPrototypeOf2.default)(InlineColorSwatch)).apply(this, arguments));
  }

  (0, _createClass3.default)(InlineColorSwatch, [{
    key: 'colorName',
    value: function colorName() {
      var t = this.props.t;


      return this.props.name || t('spree.not__available');
    }
  }, {
    key: 'render',
    value: function render() {
      var swatchStyle = {
        backgroundColor: this.props.hexRef
      };

      var theme = this.props.available ? '' : '--unavailable';

      return _react2.default.createElement(
        'div',
        { styleName: 'colorSwatch' + theme },
        _react2.default.createElement('span', { styleName: 'colorSwatch__sample', style: swatchStyle }),
        _react2.default.createElement(
          'span',
          { styleName: 'colorSwatch__label' },
          this.colorName()
        )
      );
    }
  }]);
  return InlineColorSwatch;
}(_react2.default.Component), _class2.propTypes = {
  hexRef: _react.PropTypes.string,
  name: _react.PropTypes.string,
  available: _react.PropTypes.bool
}, _class2.defaultProps = {
  hexRef: '#ebebeb',
  available: true
}, _temp)) || _class) || _class);
exports.default = InlineColorSwatch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/ColorSwatch/InlineColorSwatch.js
// module id = 581
// module chunks = 0